var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Top"),
      _vm._v(" "),
      _c("div", { staticClass: "container container--mobile" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-sm" }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-md-6" },
            [
              _c("Pagination", {
                attrs: { numberOfDots: 4, numberOfVisitedDots: 4 }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "margin-top-75" }),
              _vm._v(" "),
              _vm._m(0),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Vi behöver veta vilket år du fick din diagnos - annars väljer du vet ej."
                )
              ]),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.year,
                      expression: "year"
                    }
                  ],
                  staticClass: "form-control",
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.year = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    }
                  }
                },
                [
                  _c("option", { domProps: { value: 0 } }, [
                    _vm._v("Ange årtal")
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.years.slice().reverse(), function(year) {
                    return _c(
                      "option",
                      { key: year, domProps: { value: year } },
                      [_vm._v(_vm._s(year))]
                    )
                  })
                ],
                2
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-sm" })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-sm" }),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-6" }, [
            _c("div", { staticClass: "clearfix" }),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-primary btn-lg btn-block",
                class: _vm.previousanswer === "Vet ej" ? "previous-answer" : "",
                attrs: { disabled: _vm.year !== 0 },
                on: {
                  click: function($event) {
                    return _vm.verifyTimestamp("Vet ej")
                  }
                }
              },
              [_vm._v("\n        Vet ej\n        ")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "clearfix" }),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-primary btn-lg btn-block",
                attrs: { disabled: _vm.year === 0 },
                on: {
                  click: function($event) {
                    return _vm.verifyTimestamp("Ja")
                  }
                }
              },
              [_vm._v("Nästa")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "clearfix" }),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-outline-dark btn-lg btn-block",
                on: {
                  click: function($event) {
                    return _vm.$router.go(-1)
                  }
                }
              },
              [_vm._v("← Tillbaka")]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-sm" })
        ])
      ]),
      _vm._v(" "),
      _c("Bottom")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header-wrapper" }, [
      _c("h1", { staticClass: "text-primary-fh left-header" }, [
        _vm._v("Vilket år fick du din diagnos?")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0bd427c6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0bd427c6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VerifyTimestamp.vue
// module id = null
// module chunks = 